export default __webpack_public_path__ + "static/media/breastMovementBlogPost.28212b25.png";